import AsyncStorage from '@react-native-async-storage/async-storage';
import type { User } from '../types/api';

const ONBOARDING_KEY = 'fm_onboarding_done';
const FIRST_REMINDER_KEY = 'fm_first_reminder_shown';
const SWIPE_HINT_KEY = 'fm_swipe_hint_shown';
const CALENDAR_HINT_KEY = 'fm_calendar_hint_shown';

export function needsInitialSetup(user: User | null | undefined): boolean {
  if (!user) return false;

  const hasName = Boolean(user.displayName?.trim());
  const hasLanguage = Boolean(user.lang?.trim());
  const timezone = user.tz || user.timezone || '';
  const hasTimezone = Boolean(timezone.trim());

  return !hasName || !hasLanguage || !hasTimezone;
}

export async function hasSeenOnboarding(): Promise<boolean> {
  const val = await AsyncStorage.getItem(ONBOARDING_KEY);
  return val === '1';
}

export async function markOnboardingDone(): Promise<void> {
  await AsyncStorage.setItem(ONBOARDING_KEY, '1');
}

export async function hasSeenFirstReminderPrompt(): Promise<boolean> {
  const val = await AsyncStorage.getItem(FIRST_REMINDER_KEY);
  return val === '1';
}

export async function markFirstReminderPromptShown(): Promise<void> {
  await AsyncStorage.setItem(FIRST_REMINDER_KEY, '1');
}

export async function hasSeenSwipeHint(): Promise<boolean> {
  const val = await AsyncStorage.getItem(SWIPE_HINT_KEY);
  return val === '1';
}

export async function markSwipeHintShown(): Promise<void> {
  await AsyncStorage.setItem(SWIPE_HINT_KEY, '1');
}

export async function hasSeenCalendarHint(): Promise<boolean> {
  const val = await AsyncStorage.getItem(CALENDAR_HINT_KEY);
  return val === '1';
}

export async function markCalendarHintShown(): Promise<void> {
  await AsyncStorage.setItem(CALENDAR_HINT_KEY, '1');
}